"use client";

import { useMemo } from "react";

import { Card, CardContent } from "@/components/ui/card";
import { AvsClientStep } from "@/components/backoffice/cat/vehicle-assignment/client-step/avs/avs-client-content";
import VehicleIdentification from "@/components/backoffice/cat/vehicle-assignment/vehicle-identification-step/vehicle-identification-content";
import { useStep } from "@/hooks/use-step-handler";
import { getAvsVehicleAssignmentVisibleDefinitions } from "@/lib/cat/vehicle-assignment-avs-step-definitions";
import type { VehicleAssignmentFlowContext } from "@/lib/cat/vehicle-assignment-step-definitions";
import type { Kvps } from "@/lib/kvps";
import { AvsSalesChannelsStep } from "@/components/backoffice/cat/vehicle-assignment/sales-channels-step";
import { AvsSaleTypeStep } from "../sale-type-step/avs/avs-sale-type-content";

function VehicleAssignmentAvsSteps({
  currentKvps,
  onCanProceedChange,
}: {
  currentKvps?: Kvps | null;
  onCanProceedChange?: (canProceed: boolean) => void;
}) {
  const { step } = useStep();

  const ctx: VehicleAssignmentFlowContext = useMemo(
    () => ({ kvps: currentKvps ?? null }),
    [currentKvps],
  );

  const visibleDefinitions = useMemo(
    () => getAvsVehicleAssignmentVisibleDefinitions(ctx),
    [ctx],
  );

  const def = visibleDefinitions[step - 1];

  if (!def) {
    return (
      <Card>
        <CardContent className="p-6 text-gray-600">
          Étape invalide (WIP)
        </CardContent>
      </Card>
    );
  }

  switch (def.id) {
    case "vehicle_identification":
      return <VehicleIdentification onCanProceedChange={onCanProceedChange} />;
    case "client":
      return <AvsClientStep onCanProceedChange={onCanProceedChange} />;
    case "sales_channels":
      return <AvsSalesChannelsStep onCanProceedChange={onCanProceedChange} />;
    case "selling_type_avs":
      return <AvsSaleTypeStep />;
    default:
      return (
        <Card>
          <CardContent className="p-6 text-gray-600">
            Contenu étape (WIP) — {def.id}
          </CardContent>
        </Card>
      );
  }
}

export { VehicleAssignmentAvsSteps };
